import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { FileDownloadService } from 'src/app/services/file-download-service/file-download.service';
import { switchMap } from 'rxjs/operators';
import { PreviousQuestionPaperService } from '../../services/previous-question-paper.service';
import { PreviousQuestionPaper } from '../../models/previous-question-paper';

@Component({
  selector: 'app-previous-question-paper-details',
  templateUrl: './previous-question-paper-details.component.html',
  styleUrls: ['./previous-question-paper-details.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class PreviousQuestionPaperDetailsComponent implements OnInit {

  constructor(private fileDownloadService: FileDownloadService,
        private previousQuestionPaperService: PreviousQuestionPaperService) { }

  @Input() question_papers: Array<PreviousQuestionPaper>;
    
  ngOnInit() {
  }

  download(qp: PreviousQuestionPaper) {
    this.previousQuestionPaperService.getQuestionPaperUrlandType(qp.previous_question_paper_id).pipe(
      switchMap(res => {
        return this.fileDownloadService.downloadAndOpen(res.url, qp.title+'.pdf', res.content_type, true);
      })
    ).subscribe()
  }

}
